import { t } from "i18next";
import { useEffect, useState } from "react";
import { BottomDiv } from "../../atoms/BottomNav";
import { ConnectIconHeaderMbl, HelpIconHeaderMbl, ConnectText, NewsfeedIconHeaderMlb, HomeIcon } from "../../atoms/Header";
import WhiteConnectIcon from "../../../images/connecticon.svg";
import ConnectIconGrey from "../../../images/message_icon_grey.svg";
import ConnectIconOrange from "../../../images/message_icon_orange.svg";
import HomeIconGrey from "../../../images/home_icon_grey.svg";
import HomeIconOrange from "../../../images/home_icon_orange.svg";
import NewsfeedIconGrey from "../../../images/newsfeed_black.svg";
import newsfeed_orange from "../../../images/newsfeed_orange.svg";
import newsfeed_white from "../../../images/newsfeed_white.svg";
import getHelpIconGrey from "../../../images/help_icon_grey.svg";
import getHelpIconOrange from "../../../images/help_icon_orange.svg";
import getHelpIconWhite from "../../../images/help_icon_white.svg";
import * as Utilites from "@mywvglobal-shared/mywv-shared/common/utilities";
import { GiveIconMbl } from "../../molecule/GiveIcon/Index";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { checkDeviceType } from "../../../utilities/deviceUtilities";
import useAlert from "../../../hooks/useAlert";
import { decrypt } from "../../../utilities/tokenizer";
import { isConnectEnabledForCelebrationChild } from "../Header";

const BottomTabs = (props) => {
  const { loginReducer, sponsorshipsDataReducer, getProjectCelebrationDetailsReducer } = useSelector((state) => state);
  const { worldReducer } = useSelector((state) => state);
  const navigate = useNavigate();
  const { setAlert } = useAlert();
  const params = useParams();
  const [displayGive, setdisplayGive] = useState(false);
  const [displaynewsfeed, setDisplaynewsfeed] = useState(false);
  const [showNoSponsorshipMessage, setShowNoSponsorshipMessage] = useState(false);
  const [refreshComponent, setRefreshComponent] = useState(null);
  const ifSponsoredChildAvailable = (worldReducer?.childList?.length > 0) && (worldReducer?.childList?.some(child => !!child.childCode));
  const eLetterDisableDate = getProjectCelebrationDetailsReducer?.getProjectCelebrationDetails?.community?.eLetterDisableDate;
  const [selectedChildData, setSelectedChildData] = useState();

  useEffect(() => {
    setSelectedChildData(sponsorshipsDataReducer?.getSponsorshipsData?.activeSponsorships?.filter((item) => { return item?.childCode == decrypt(params?.childcode) })[0]);
  }, [params, sponsorshipsDataReducer?.getSponsorshipsData]);

  const checkSponsorship = () => {
    if (!ifSponsoredChildAvailable) {
      setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
      return;
    }
  }

  const navigateConnect = () => {
    localStorage.setItem("isWriteALetter", "false");
    if (!ifSponsoredChildAvailable) {
      setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
      return;
    }
    if (params?.childcode) {
      navigate(`/connect/${params?.childcode}`)
    } else {
      navigate(`/connect/${(props?.selectedChild)}`)
    }
  }

  const navigateCommunityHome = () => {
    if (!ifSponsoredChildAvailable) {
      setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
      return;
    }
    if (params?.childcode) {
      navigate(`/communityhomeview/${params?.childcode}`)
    } else {
      navigate(`/communityhomeview/${(props?.selectedChild)}`)
    }
  }
  
  //cta code change start
  const navigateFeed = () => {
    if (!ifSponsoredChildAvailable) {
      setShowNoSponsorshipMessage(!showNoSponsorshipMessage);
      return;
    }
    navigate("/newsandstories", { state: { childcode: props?.selectedChild } });
  };

  //cta code change end
  useEffect(() => {
    if (Utilites.GetSOBasedConfiguration(
      loginReducer?.getSOConfiguration,
      "Gift",
      "SendAGift",
    ) || (Utilites.GetSOBasedConfiguration(
      loginReducer?.getSOConfiguration,
      "Gift",
      "SendAGift",
    ) && Utilites.GetSOBasedConfiguration(
      loginReducer?.getSOConfiguration,
      "Gift",
      "Donate",
    ))) { setdisplayGive(true) }
    if (!(checkDeviceType() === "desktop") && Utilites.GetSOBasedConfiguration(
      loginReducer?.getSOConfiguration,
      "StoriesInBottomNavBar",
      "",
    )) {
      setDisplaynewsfeed(true)
    }
  }, [loginReducer?.getSOConfiguration]);

  useEffect(() => {
    if (showNoSponsorshipMessage) {
      const IsChildAvaialble = worldReducer?.childList?.some((e) => e?.isSponsor == false);
      if (!IsChildAvaialble) {
        setAlert(t("NoSponsorshipsFound"),
          t("NoSponsorshipDescription"),
          t("NoSponsorshipDescription2", { AccountDetails: t("AccountDetails"), FindNewChild: t("FindNewChild") }),
          [t("AccountDetails"), t("FindNewChild")],
          "error", false, false, false)
        setShowNoSponsorshipMessage(false);
      }
    }
  }, [worldReducer, showNoSponsorshipMessage]);

  useEffect(() => {
    const resizeHandler = () => {
      setRefreshComponent(Math.random());
    };
    window.addEventListener("resize", resizeHandler);
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);

  return (
    <>
      <BottomDiv
        isDesktop={checkDeviceType() === "desktop"}
        nobg={props?.community}
        station={props?.station}
        key={refreshComponent}
      >
        {<HomeIcon community={props?.community} onClick={() => navigateCommunityHome()}>
          {window.location.pathname.includes("home") || window.location.pathname.includes("communityhomeview") ||
            window.location.pathname.includes("childprofile") || window.location.pathname.includes("childcommunity") ||
            window.location.pathname.includes("community/station") ?
            <img src={HomeIconOrange} alt="" /> :
            <img src={HomeIconGrey} alt="" />}
          <ConnectText community={props?.community}>{t("Home")}</ConnectText>
        </HomeIcon>}

        {(props.home || !(worldReducer?.childList?.length > 0)) || !isConnectEnabledForCelebrationChild(selectedChildData, eLetterDisableDate) ? null :
          <ConnectIconHeaderMbl onClick={() => navigateConnect()}>
            {window.location.pathname.includes("/connect") ? <img src={ConnectIconOrange} alt="" /> :
              <img src={props?.community ? WhiteConnectIcon : ConnectIconGrey} alt="" />}
            <ConnectText community={props?.community}>{t("Connect")}</ConnectText>
          </ConnectIconHeaderMbl>}

        {displayGive &&
          <GiveIconMbl checkSponsorship={checkSponsorship} community={props?.community} selectedChild={props?.selectedChild} suggestions={props?.searchChildData} />
        }

        {displaynewsfeed && (
          //cta code change  - onclick added
          <NewsfeedIconHeaderMlb onClick={navigateFeed}>
            {window.location.href.includes("newsandstories") ? (
              <img src={newsfeed_orange} alt="" />
            ) : (
              <img src={props?.community ? newsfeed_white : NewsfeedIconGrey}  alt="" />
            )}
            <ConnectText community={props?.community}>
              {t("Newsfeed")}
            </ConnectText>
          </NewsfeedIconHeaderMlb>
        )}

        {/*cta code change  - onclick added */}
        <HelpIconHeaderMbl onClick={() => navigate("/getHelp", { state: { childcode: props?.selectedChild } })}>
          {window.location.pathname.includes("getHelp") ? <img src={getHelpIconOrange} alt="" /> :
            <img src={props?.community ? getHelpIconWhite : getHelpIconGrey} alt="" />}
          <ConnectText community={props?.community}>{t("GetHelp")}</ConnectText>
        </HelpIconHeaderMbl>
      </BottomDiv>
    </>
  )
}

export default BottomTabs;